import {
  CUSTOMER_SESSION,
  CUSTOMER_SESSION_SUCCESS,
  CUSTOMER_SESSION_ERROR,
  CUSTOMER_SESSION_EMPTY,
} from '../../actions';

const initialState = {
  data: null,
  loading: false,
  success: false,
  error: false,
  message: null,
  statusCode: null,
};

const CustomerSession = (state = initialState, action) => {
  switch (action.type) {
    case CUSTOMER_SESSION:
      return {
        ...state,
        loading: true,
        success: false,
        error: false,
        message: null,
        statusCode: null,
      };

    case CUSTOMER_SESSION_SUCCESS:
      return {
        ...state,
        data: action.payload,
        loading: false,
        success: true,
        error: false,
        message: null,
        statusCode: 200,
      };

    case CUSTOMER_SESSION_ERROR: {
      const statusCode = action.payload?.statusCode ?? null;
      const message = action.payload?.message ?? null;

      // Handle only 406 specially
      if (statusCode === 406) {
        return {
          ...state,
          data: null,
          loading: false,   // stop loader
          success: false,
          error: false,     // treat as "no session" (keeps rest flow same)
          message: null,
          statusCode: 406,
        };
      }

      // All other errors same as before
      return {
        ...state,
        data: null,
        loading: false,
        success: false,
        error: true,
        message: message ?? action.payload,
        statusCode,
      };
    }

    case CUSTOMER_SESSION_EMPTY:
      return { ...initialState };

    default:
      return state;
  }
};

export default CustomerSession;
